import { renderStoryblokRichText } from '@utils/renderStoryblokRichText';
import classNames from 'classnames';

import { TimelineListStoryblok } from '../types/generated-storyblok';

interface ContentBlockTimelineProps {
  blok: TimelineListStoryblok;
}

export const ContentBlockTimeline = ({ blok }: ContentBlockTimelineProps) => {
  return (
    <div className="mx-auto w-full max-w-lg">
      {blok.items.map((item, index) => {
        const isFirst = index === 0;
        const isLast = index + 1 === blok.items.length;

        return (
          <div
            key={item._uid}
            className={classNames(
              'relative flex',
              'before:absolute before:bottom-0 before:top-0 before:w-px before:translate-x-1.5 before:bg-divider/20 before:content-[""]',
              'after:absolute after:top-1 after:h-3 after:w-3 after:rounded-full after:bg-white after:ring-2 after:ring-divider/20 after:content-[""]',
              { 'before:top-2.5': isFirst },
              { 'before:bottom-inherit before:h-2.5': isLast },
            )}
          >
            <div className="flex flex-col gap-2 pl-6">
              <div className="w-full">
                <p className="font-bold">{item.title}</p>
              </div>
              <div className="w-full">
                {renderStoryblokRichText(item.content)}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
